const BASE_URL =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://api.pople.credit/api/v1/admin/'
    : process.env.REACT_APP_ENV === 'local'
    ? 'http://localhost:8080/api/v1/admin/'
    : 'https://api-dev.pople.credit/api/v1/admin/';

export { BASE_URL };
